<div class="fx-layout-row fx-layout-align-center-center">
  <div class="fx-flex-80pc">
    <h4 class="white" *ngIf="courseName">
      Course: {{courseName}}<span *ngIf="chapterName"> / Chapter: {{chapterName}}</span>
    </h4>
    <p-table #dt [columns]="cols" [value]="quizzes" [paginator]="true" selectionMode="single" [rows]="rows"
      [lazy]="true" (onLazyLoad)="loadQuizzesLazy($event)" [totalRecords]="totalRecords" [loading]="loading"
      (onRowSelect)="onRowSelect($event)">
      <!-- <ng-template pTemplate="caption">
          <div style="text-align: right">
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText class="margin0"  size="50" placeholder="Global Filter"
              (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
          </div>
        </ng-template> -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <input *ngSwitchCase="'QuizID'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'QuizTitle'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'QuizLocation'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'QuizOrder'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
            <input *ngSwitchCase="'QuestionLimit'" pInputText type="text"
              (input)="dt.filter($event.target.value, col.field, 'contains')">
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns">
            <span>{{rowData[col.field]}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary" let-rowData>
        <div style="text-align:left">
          <button type="button" pButton (click)="showDialogToAdd()" label="Add"></button>
        </div>
      </ng-template>
    </p-table>

    <p-dialog header="Quiz Details" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true"
      [style]="{width: '700px', height: '800px'}" (visibleChange)="handleClose()">
      <div class="red-text" *ngIf="errorMessage">{{ errorMessage }}</div>
      <div class="alert-success" *ngIf="successMessage">{{ successMessage }}</div>
      <div class="ui-g ui-fluid" *ngIf="quiz">
        <div class="ui-g-12">
          <div class="ui-g-4">
            <label for="sourceschool">QuizId</label>
          </div>
          <div class="ui-g-8">
            {{ quiz.QuizID }}
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="QuizTitle">Quiz Title*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="QuizTitle" [(ngModel)]="quiz.QuizTitle" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="Course">Course*</label>
          </div>
          <div class="ui-g-8 pad0">
            <p-dropdown id="Course" [options]="courses" [(ngModel)]="quiz.courseId" (onChange)="onChangeCourse($event)">
            </p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="QuizLocation">Quiz Location*</label>
          </div>
          <div class="ui-g-8 pad0">
            <p-dropdown id="QuizLocation2" [options]="quizLocations" [(ngModel)]="quiz.QuizLocation2"
              (onChange)="onChangeLocation($event)"></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="QuizOrder">Quiz Order*</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="QuizOrder" [(ngModel)]="quiz.QuizOrder" required />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="QuestionLimit">Question Limit</label>
          </div>
          <div class="ui-g-8 pad0">
            <input pInputText class="margin0" id="QuestionLimit" [(ngModel)]="quiz.QuestionLimit" />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4 pad0">
            <label for="Link">Link</label>
          </div>
          <div class="ui-g-8 pad0">
            <p class="margin0" id="Link">{{link}} &nbsp; <fa-icon [icon]="faCopy" [cdkCopyToClipboard]="link"></fa-icon>
            </p>
          </div>
        </div>        

      </div>
      <ng-template pTemplate="footer">
        <div class="ui-dialog-buttonpane ui-helper-clearfix" *ngIf="quiz">
          <a target="_blank" (click)="gotoQuestions($event)" type="button" pButton label="Quiz Questions"
            class="left"></a>
          <button type="button" pButton (click)="delete()" label="Delete" class="left"></button>
          <button type="button" pButton (click)="save()"
            [disabled]="!quiz.QuizTitle || !quiz.QuizLocation || !quiz.QuizLocation2 || !quiz.QuizOrder"
            label="Save"></button>
        </div>

      </ng-template>

    </p-dialog>
  </div>
</div>
